import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import React from "react";

export const SearchNotFound = ({ title, desc }) => {
  return (
    <div className="flex flex-col items-center text-center space-y-2 ">
      <span className="p-3 rounded-full bg-custom-link-bg-color">
        <MagnifyingGlassIcon
          width={20}
          height={20}
          style={{ color: "white" }}
        />
      </span>
      <p className="text-lg text-gray-700 font-semibold">{title}</p>
      <p className="text-gray-500">{desc} </p>
    </div>
  );
};
